(function () {
  "use strict";

  function initDemoDialog(page) {
    var openBtns = Array.from(page.querySelectorAll("[data-melo-demo-open]"));
    var dialog = page.querySelector("[data-melo-demo-dialog]");
    if (!openBtns.length || !dialog || typeof dialog.showModal !== "function") {
      return;
    }

    var image = dialog.querySelector("[data-melo-demo-image]");
    var thumbs = Array.from(dialog.querySelectorAll("[data-melo-demo-thumb]"));
    var prevBtn = dialog.querySelector("[data-melo-demo-prev]");
    var nextBtn = dialog.querySelector("[data-melo-demo-next]");
    var closeBtns = dialog.querySelectorAll("[data-melo-demo-close]");
    var activeIndex = 0;

    function setActive(index) {
      if (!thumbs.length || !image) {
        return;
      }

      if (index < 0) {
        index = thumbs.length - 1;
      }
      if (index >= thumbs.length) {
        index = 0;
      }

      activeIndex = index;
      var thumb = thumbs[activeIndex];
      var src = thumb.getAttribute("data-src");
      var alt = thumb.getAttribute("data-alt") || "";

      if (src) {
        image.setAttribute("src", src);
        image.setAttribute("alt", alt);
      }

      thumbs.forEach(function (item, i) {
        var isActive = i === activeIndex;
        item.classList.toggle("is-active", isActive);
        if (isActive) {
          item.setAttribute("aria-current", "true");
        } else {
          item.removeAttribute("aria-current");
        }
      });
    }

    function openDemo() {
      setActive(0);
      dialog.showModal();
      document.documentElement.classList.add("melo-app-demo-open");
    }

    function closeDemo() {
      if (dialog.open) {
        dialog.close();
      }
      document.documentElement.classList.remove("melo-app-demo-open");
    }

    openBtns.forEach(function (openBtn) {
      openBtn.addEventListener("click", openDemo);
    });

    closeBtns.forEach(function (btn) {
      btn.addEventListener("click", closeDemo);
    });

    dialog.addEventListener("click", function (event) {
      if (event.target === dialog) {
        closeDemo();
      }
    });

    dialog.addEventListener("close", function () {
      document.documentElement.classList.remove("melo-app-demo-open");
    });

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener("click", function () {
        setActive(index);
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener("click", function () {
        setActive(activeIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", function () {
        setActive(activeIndex + 1);
      });
    }

    dialog.addEventListener("keydown", function (event) {
      if (!dialog.open || thumbs.length < 2) {
        return;
      }
      if (event.key === "ArrowLeft") {
        event.preventDefault();
        setActive(activeIndex - 1);
      }
      if (event.key === "ArrowRight") {
        event.preventDefault();
        setActive(activeIndex + 1);
      }
    });
  }

  function initCarousel(root) {
    var track = root.querySelector("[data-melo-carousel-track]");
    var prev = root.querySelector("[data-melo-carousel-prev]");
    var next = root.querySelector("[data-melo-carousel-next]");
    if (!track || !prev || !next) {
      return;
    }

    var slides = Array.from(track.querySelectorAll(".melo-app-related-card"));

    function hideControls() {
      prev.hidden = true;
      next.hidden = true;
      root.classList.remove("melo-app-related-carousel--scrollable");
    }

    if (slides.length <= 1) {
      hideControls();
      return;
    }

    function isScrollable() {
      return track.scrollWidth - track.clientWidth > 1;
    }

    function getSlideOffset(index) {
      if (index <= 0) {
        return 0;
      }
      return slides[index].offsetLeft - slides[0].offsetLeft;
    }

    function getActiveIndex() {
      var scrollLeft = track.scrollLeft;
      var activeIndex = 0;

      slides.forEach(function (slide, index) {
        if (getSlideOffset(index) <= scrollLeft + 8) {
          activeIndex = index;
        }
      });

      return activeIndex;
    }

    function resetToStart() {
      track.scrollLeft = 0;
    }

    function syncControls() {
      if (!isScrollable()) {
        resetToStart();
        hideControls();
        return;
      }

      root.classList.add("melo-app-related-carousel--scrollable");

      var maxScroll = track.scrollWidth - track.clientWidth;
      prev.hidden = track.scrollLeft <= 8;
      next.hidden = track.scrollLeft >= maxScroll - 8;
    }

    function scrollToSlide(index) {
      if (!isScrollable()) {
        return;
      }

      if (index < 0) {
        index = 0;
      }
      if (index >= slides.length) {
        index = slides.length - 1;
      }

      track.scrollTo({
        left: getSlideOffset(index),
        behavior: "smooth",
      });
    }

    prev.addEventListener("click", function () {
      var target = getActiveIndex() - 1;
      scrollToSlide(target < 0 ? 0 : target);
    });

    next.addEventListener("click", function () {
      scrollToSlide(getActiveIndex() + 1);
    });

    track.addEventListener(
      "scroll",
      function () {
        if (track.scrollLeft < 0) {
          track.scrollLeft = 0;
        }
        syncControls();
      },
      { passive: true },
    );

    window.addEventListener("resize", syncControls, { passive: true });

    if (typeof ResizeObserver !== "undefined") {
      new ResizeObserver(syncControls).observe(track);
    }

    resetToStart();
    syncControls();
    requestAnimationFrame(function () {
      resetToStart();
      syncControls();
    });
  }

  function initFeatureTabs(root) {
    var tabs = Array.from(root.querySelectorAll("[data-melo-feature-tab]"));
    if (!tabs.length) {
      return;
    }

    var duration =
      parseInt(root.getAttribute("data-melo-feature-duration"), 10) || 7000;
    var autoplay = root.hasAttribute("data-melo-feature-autoplay");
    var prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;
    var activeIndex = 0;
    var timerId = null;
    var paused = false;
    var tabEndAt = 0;
    var remainingMs = duration;
    var page = root.closest(".melo-app-page");
    var previewImages = page
      ? Array.from(page.querySelectorAll("[data-melo-feature-preview-image]"))
      : [];
    var autoplayToggle = page
      ? page.querySelector("[data-melo-feature-autoplay-toggle]")
      : null;
    var canSyncPreview =
      previewImages.length >= 2 &&
      tabs.some(function (tab) {
        return tab.hasAttribute("data-melo-feature-image");
      });

    root.style.setProperty("--melo-feature-tab-duration", duration + "ms");

    function clearTimer() {
      if (timerId) {
        clearTimeout(timerId);
        timerId = null;
      }
    }

    function updateAutoplayToggle() {
      if (!autoplayToggle) {
        return;
      }

      autoplayToggle.hidden = !autoplay || prefersReducedMotion;
      autoplayToggle.setAttribute("aria-pressed", paused ? "true" : "false");
      autoplayToggle.setAttribute(
        "aria-label",
        paused
          ? "Reanudar recorrido de capacidades"
          : "Pausar recorrido de capacidades",
      );
      root.classList.toggle("is-autoplay-paused", paused);
    }

    function pauseAutoplay() {
      if (!autoplay || prefersReducedMotion || paused) {
        return;
      }

      paused = true;
      remainingMs = Math.max(0, tabEndAt - Date.now()) || duration;
      clearTimer();
      updateAutoplayToggle();
    }

    function resumeAutoplay() {
      if (!autoplay || prefersReducedMotion || !paused) {
        return;
      }

      paused = false;
      updateAutoplayToggle();
      clearTimer();
      tabEndAt = Date.now() + remainingMs;
      timerId = setTimeout(function () {
        activate((activeIndex + 1) % tabs.length);
      }, remainingMs);
    }

    function toggleAutoplay() {
      if (paused) {
        resumeAutoplay();
      } else {
        pauseAutoplay();
      }
    }

    function syncPreviewImage(tab) {
      if (!canSyncPreview) {
        return;
      }

      var src = tab.getAttribute("data-melo-feature-image");
      var alt = tab.getAttribute("data-melo-feature-alt") || "";
      if (!src) {
        return;
      }

      var current = previewImages.find(function (img) {
        return img.classList.contains("is-active");
      });
      var next = previewImages.find(function (img) {
        return img !== current;
      });

      if (!current || !next) {
        return;
      }

      if (current.getAttribute("src") === src) {
        current.setAttribute("alt", alt);
        return;
      }

      next.setAttribute("src", src);
      next.setAttribute("alt", alt);
      next.removeAttribute("aria-hidden");
      current.setAttribute("aria-hidden", "true");
      next.classList.add("is-active");
      current.classList.remove("is-active");
    }

    function scheduleNext() {
      clearTimer();

      if (!autoplay || prefersReducedMotion || paused) {
        return;
      }

      remainingMs = duration;
      tabEndAt = Date.now() + duration;
      timerId = setTimeout(function () {
        activate((activeIndex + 1) % tabs.length);
      }, duration);
    }

    function activate(index, options) {
      options = options || {};
      activeIndex = index;
      var tab = tabs[index];

      tabs.forEach(function (item, i) {
        var isActive = i === index;
        item.classList.toggle("is-active", isActive);
        if (isActive) {
          item.setAttribute("aria-current", "true");
        } else {
          item.removeAttribute("aria-current");
        }
        item.tabIndex = isActive ? 0 : -1;
      });

      syncPreviewImage(tab);
      if (options.scheduleAutoplay !== false) {
        scheduleNext();
      }
    }

    var tabsContainer = root.querySelector(".melo-app-feature-tabs");
    var hoverCapable = window.matchMedia("(hover: hover) and (pointer: fine)").matches;

    tabs.forEach(function (tab, index) {
      tab.tabIndex = index === 0 ? 0 : -1;

      if (hoverCapable) {
        tab.addEventListener("mouseenter", function () {
          if (autoplay && !prefersReducedMotion && !paused) {
            pauseAutoplay();
          }
          activate(index, { scheduleAutoplay: false });
        });
      } else {
        tab.addEventListener("click", function () {
          activate(index);
        });
      }

      tab.addEventListener("keydown", function (event) {
        var nextIndex = index;
        if (event.key === "ArrowRight" || event.key === "ArrowDown") {
          nextIndex = (index + 1) % tabs.length;
        } else if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
          nextIndex = (index - 1 + tabs.length) % tabs.length;
        } else if (event.key === "Home") {
          nextIndex = 0;
        } else if (event.key === "End") {
          nextIndex = tabs.length - 1;
        } else {
          return;
        }
        event.preventDefault();
        tabs[nextIndex].focus();
        activate(nextIndex);
      });
    });

    if (tabsContainer && hoverCapable && autoplay && !prefersReducedMotion) {
      tabsContainer.addEventListener("mouseleave", function () {
        if (!paused) {
          return;
        }
        remainingMs = duration;
        resumeAutoplay();
      });
    }

    if (autoplayToggle) {
      autoplayToggle.addEventListener("click", toggleAutoplay);
    }

    updateAutoplayToggle();
    activate(0);
  }

  function initRateDemo(root) {
    var bentoMode = root.getAttribute("data-melo-rate-demo-bento-mode") || "";
    var isBentoProblem = bentoMode === "problem";
    var isBentoCheckout = bentoMode === "checkout";
    var isBentoStatic = isBentoProblem || isBentoCheckout;
    var bentoFocus = root.getAttribute("data-melo-rate-demo-bento-focus") || "";
    var isBentoSummaryFocus = bentoFocus === "summary";
    var instanceId = root.getAttribute("data-melo-rate-demo-instance") || "default";
    var methodRadioName = "melo-rate-demo-method-" + instanceId;
    var modeButtons = Array.from(
      root.querySelectorAll("[data-melo-rate-mode]"),
    );
    var citySelect = root.querySelector("[data-melo-rate-city]");
    var methodsEl = root.querySelector("[data-melo-rate-methods]");
    var captionEl = root.querySelector("[data-melo-rate-caption]");
    var shippingEl = root.querySelector("[data-melo-rate-shipping]");
    var shippingTagEl = root.querySelector("[data-melo-rate-shipping-tag]");
    var savingsEl = root.querySelector("[data-melo-rate-savings]");
    var totalEl = root.querySelector("[data-melo-rate-total]");
    var panel =
      root.querySelector("[data-melo-rate-demo-panel]") ||
      root.querySelector("#rate-demo-panel");
    var demoStage = root.querySelector(".melo-app-rate-demo-stage");
    var playbackRoot = root.querySelector(".melo-app-rate-demo");
    var cursor = root.querySelector("[data-melo-rate-demo-cursor]");
    var citySelectWrap = citySelect
      ? citySelect.closest("[data-melo-rate-city-wrap]")
      : null;
    var embedShell = root.querySelector(".melo-app-rate-demo-embed-shell");
    var sandbox = root.querySelector(".melo-app-rate-demo-sandbox");
    var cityMenu = citySelectWrap
      ? citySelectWrap.querySelector("[data-melo-rate-city-menu]")
      : null;
    var cityOptions = cityMenu
      ? Array.from(
          cityMenu.querySelectorAll(".melo-app-rate-demo-select-option"),
        )
      : [];
    var beforeButton = modeButtons.find(function (button) {
      return button.getAttribute("data-melo-rate-mode") === "before";
    });
    var afterButton = modeButtons.find(function (button) {
      return button.getAttribute("data-melo-rate-mode") === "after";
    });
    var takeControlBtn = root.querySelector("[data-melo-rate-demo-take-control]");

    if (!citySelect || !methodsEl || !playbackRoot) {
      return;
    }

    if (!isBentoStatic && (!modeButtons.length || !panel)) {
      return;
    }

    var userControlled = false;
    var userInteractionReady = false;

    var scenarioAttr = root.getAttribute("data-melo-checkout-demo") || "rates";

    var subtotal = 29;
    var cityLabels = {
      "los-angeles": "Los Angeles",
      "san-francisco": "San Francisco",
      "san-diego": "San Diego",
    };

    var scenarios = {
      rates: {
        beforeRates: [
          {
            id: "before-standard",
            title: "California Standard — 3 a 5 días háb.",
            price: "$7.99",
            description:
              "LOS ANGELES / SAN FRANCISCO / SAN DIEGO. Shopify muestra las 3 tarifas del estado aunque el comprador ya ingresó su ciudad.",
          },
          {
            id: "before-express",
            title: "California Express — 1 a 2 días háb.",
            price: "$14.99",
            description:
              "LOS ANGELES / SAN FRANCISCO / SAN DIEGO. Misma opción para todo California; hay que aclarar en la descripción a qué ciudad aplica.",
          },
          {
            id: "before-economy",
            title: "California Economy — 5 a 8 días háb.",
            price: "$5.49",
            description:
              "LOS ANGELES / SAN FRANCISCO / SAN DIEGO. El checkout no puede filtrar por ciudad: aparecen tarifas que no corresponden.",
          },
        ],
        afterRatesByCity: {
          "los-angeles": [
            {
              id: "after-la",
              title: "Los Angeles Standard — 2 a 4 días háb.",
              price: "$4.99",
              description:
                "LOS ANGELES. Solo la tarifa que aplica a la dirección del comprador.",
            },
          ],
          "san-francisco": [
            {
              id: "after-sf",
              title: "Bay Area Delivery — 1 a 3 días háb.",
              price: "$6.50",
              description:
                "SAN FRANCISCO. Una sola opción relevante en checkout.",
            },
          ],
          "san-diego": [
            {
              id: "after-sd",
              title: "San Diego Standard — 2 a 4 días háb.",
              price: "$5.25",
              description:
                "SAN DIEGO. Menos ruido, más claridad al cerrar la compra.",
            },
          ],
        },
        captionBefore: function (city) {
          return (
            "Al elegir " +
            city +
            ", siguen apareciendo las 3 tarifas del estado. Shopify nativo no filtra por ciudad."
          );
        },
        captionAfter: function (city) {
          return (
            "En " +
            city +
            " solo aparece la tarifa que aplica a esa ciudad. Menos ruido, más claridad en checkout."
          );
        },
      },
      discounts: {
        beforeRates: [
          {
            id: "before-standard",
            title: "California Standard — 3 a 5 días háb.",
            price: "$6.39",
            compareAtPrice: "$7.99",
            description:
              "LOS ANGELES / SAN FRANCISCO / SAN DIEGO. 20% off estatal: la misma rebaja para todo California.",
          },
          {
            id: "before-express",
            title: "California Express — 1 a 2 días háb.",
            price: "$11.99",
            compareAtPrice: "$14.99",
            description:
              "LOS ANGELES / SAN FRANCISCO / SAN DIEGO. Shopify nativo aplica un solo descuento por estado a todas las tarifas.",
          },
          {
            id: "before-economy",
            title: "California Economy — 5 a 8 días háb.",
            price: "$4.39",
            compareAtPrice: "$5.49",
            description:
              "LOS ANGELES / SAN FRANCISCO / SAN DIEGO. No hay forma nativa de variar el descuento por ciudad.",
          },
        ],
        afterRatesByCity: {
          "los-angeles": [
            {
              id: "after-la-standard",
              title: "California Standard — 3 a 5 días háb.",
              price: "$0.00",
              compareAtPrice: "$7.99",
              isFree: true,
              description:
                "LOS ANGELES. Envío gratis en todas las tarifas de esta ciudad.",
            },
            {
              id: "after-la-express",
              title: "California Express — 1 a 2 días háb.",
              price: "$0.00",
              compareAtPrice: "$14.99",
              isFree: true,
              description:
                "LOS ANGELES. Melo aplica el descuento de ciudad a Express también.",
            },
            {
              id: "after-la-economy",
              title: "California Economy — 5 a 8 días háb.",
              price: "$0.00",
              compareAtPrice: "$5.49",
              isFree: true,
              description:
                "LOS ANGELES. Economy también queda en gratis con la regla de ciudad.",
            },
          ],
          "san-francisco": [
            {
              id: "after-sf-standard",
              title: "California Standard — 3 a 5 días háb.",
              price: "$4.00",
              compareAtPrice: "$7.99",
              description:
                "SAN FRANCISCO. 50% off en Standard para esta ciudad.",
            },
            {
              id: "after-sf-express",
              title: "California Express — 1 a 2 días háb.",
              price: "$7.50",
              compareAtPrice: "$14.99",
              description:
                "SAN FRANCISCO. 50% off también en Express.",
            },
            {
              id: "after-sf-economy",
              title: "California Economy — 5 a 8 días háb.",
              price: "$2.75",
              compareAtPrice: "$5.49",
              description:
                "SAN FRANCISCO. 50% off en Economy para la misma ciudad.",
            },
          ],
          "san-diego": [
            {
              id: "after-sd-standard",
              title: "California Standard — 3 a 5 días háb.",
              price: "$4.99",
              compareAtPrice: "$7.99",
              description:
                "SAN DIEGO. $3 de descuento fijo en Standard.",
            },
            {
              id: "after-sd-express",
              title: "California Express — 1 a 2 días háb.",
              price: "$11.99",
              compareAtPrice: "$14.99",
              description:
                "SAN DIEGO. $3 de descuento fijo también en Express.",
            },
            {
              id: "after-sd-economy",
              title: "California Economy — 5 a 8 días háb.",
              price: "$2.49",
              compareAtPrice: "$5.49",
              description:
                "SAN DIEGO. $3 de descuento fijo en Economy.",
            },
          ],
        },
        captionBefore: function (city) {
          return (
            "Aunque elijas " +
            city +
            ", Shopify nativo solo aplica un descuento general por estado a todas las tarifas."
          );
        },
        captionAfter: function (city) {
          return (
            "En " +
            city +
            ", Melo aplica el descuento de esa ciudad a todas las tarifas automáticamente."
          );
        },
      },
      rules: {
        beforeRates: [
          {
            id: "before-standard",
            title: "California Standard — 3 a 5 días háb.",
            price: "$7.99",
            description:
              "LOS ANGELES / SAN FRANCISCO / SAN DIEGO. Las 3 opciones del estado aparecen sin importar la ciudad.",
          },
          {
            id: "before-express",
            title: "California Express — 1 a 2 días háb.",
            price: "$14.99",
            description:
              "LOS ANGELES / SAN FRANCISCO / SAN DIEGO. Shopify no puede ocultar ni personalizar métodos según la ciudad.",
          },
          {
            id: "before-economy",
            title: "California Economy — 5 a 8 días háb.",
            price: "$5.49",
            description:
              "LOS ANGELES / SAN FRANCISCO / SAN DIEGO. El comprador ve opciones que a veces no le corresponden.",
          },
        ],
        afterRatesByCity: {
          "los-angeles": [
            {
              id: "after-la-standard",
              title: "California Standard — 3 a 5 días háb.",
              price: "$7.99",
              description:
                "LOS ANGELES. Standard disponible en esta ciudad. Mismo precio que en Shopify.",
            },
            {
              id: "after-la-economy",
              title: "California Economy — 5 a 8 días háb.",
              price: "$5.49",
              description:
                "LOS ANGELES. Economy disponible en esta ciudad. Express no aparece porque no aplica aquí.",
            },
          ],
          "san-francisco": [
            {
              id: "after-sf-renamed",
              title: "Envío a domicilio — 3 a 5 días háb.",
              price: "$7.99",
              description:
                "SAN FRANCISCO. Nombre más claro para que el comprador entienda la condición de entrega.",
            },
            {
              id: "after-sf-express",
              title: "California Express — 1 a 2 días háb.",
              price: "$14.99",
              description:
                "SAN FRANCISCO. Express sigue disponible. Economy no aparece en esta ciudad.",
            },
          ],
          "san-diego": [
            {
              id: "after-sd-express",
              title: "California Express — 1 a 2 días háb.",
              price: "$14.99",
              description:
                "SAN DIEGO. Solo queda Express, como configuraste para esta ciudad.",
            },
          ],
        },
        captionBefore: function (city) {
          return (
            "Aunque elijas " +
            city +
            ", el checkout sigue mostrando todas las tarifas. Shopify no puede ocultar ni personalizar métodos según la dirección."
          );
        },
        captionAfter: function (city) {
          var byCity = {
            "los-angeles":
              "En " +
              city +
              ", Melo oculta Express. El comprador solo ve Standard y Economy — mismos precios, menos confusión.",
            "san-francisco":
              "En " +
              city +
              ", Melo renombra Standard y oculta Economy. Nombres más claros y solo lo que corresponde a esa ciudad.",
            "san-diego":
              "En " +
              city +
              ", Melo deja solo Express. Una sola opción cuando así lo definiste para esta ciudad.",
          };
          return byCity[citySelect.value] || byCity["los-angeles"];
        },
      },
    };

    var scenario = scenarios[scenarioAttr] ? scenarioAttr : "rates";
    var scenarioConfig = scenarios[scenario] || scenarios.rates;
    var beforeRates = scenarioConfig.beforeRates;
    var afterRatesByCity = scenarioConfig.afterRatesByCity;

    var mode = "before";
    var playbackActive = false;
    var playbackTimeouts = [];
    var prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    function escapeHtml(value) {
      return String(value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    }

    function parsePrice(value) {
      return parseFloat(String(value).replace(/[^0-9.]/g, "")) || 0;
    }

    function formatMoney(amount) {
      return "$" + amount.toFixed(2);
    }

    function updateSummary(rate) {
      var amount = rate && rate.isFree ? 0 : parsePrice(rate ? rate.price : "0");
      var compareAt = rate && rate.compareAtPrice ? parsePrice(rate.compareAtPrice) : 0;
      var isFree = Boolean(rate && (rate.isFree || amount === 0));
      var hasDiscount = Boolean(rate && rate.compareAtPrice && compareAt > amount);

      if (shippingEl) {
        if (hasDiscount) {
          shippingEl.classList.add("is-discounted");
          shippingEl.innerHTML =
            '<span class="melo-app-rate-demo-summary-compare">' +
            escapeHtml(rate.compareAtPrice) +
            "</span>" +
            (isFree
              ? '<span class="melo-app-rate-demo-summary-free">Gratis</span>'
              : '<span class="melo-app-rate-demo-summary-price">' +
                escapeHtml(rate.price) +
                "</span>");
        } else {
          shippingEl.classList.remove("is-discounted");
          shippingEl.textContent = rate ? rate.price : "$0.00";
        }
      }

      if (shippingTagEl && !isBentoSummaryFocus) {
        if (hasDiscount) {
          shippingTagEl.hidden = false;
          shippingTagEl.innerHTML =
            '<span class="melo-app-rate-demo-summary-tag-icon" aria-hidden="true"></span>' +
            '<span class="melo-app-rate-demo-summary-tag-label">' +
            escapeHtml(isFree ? "ENVÍO GRATIS" : "DESCUENTO DE ENVÍO") +
            "</span>";
        } else {
          shippingTagEl.hidden = true;
          shippingTagEl.innerHTML = "";
        }
      }

      if (totalEl) {
        totalEl.textContent = formatMoney(subtotal + amount);
      }

      if (savingsEl && !isBentoSummaryFocus) {
        if (hasDiscount) {
          savingsEl.hidden = false;
          savingsEl.innerHTML =
            '<span class="melo-app-rate-demo-summary-tag-icon" aria-hidden="true"></span>' +
            '<span class="melo-app-rate-demo-summary-savings-label">AHORRO TOTAL ' +
            escapeHtml(formatMoney(compareAt - amount)) +
            "</span>";
        } else {
          savingsEl.hidden = true;
          savingsEl.innerHTML = "";
        }
      }
    }

    function getRates() {
      if (mode === "before") {
        return beforeRates;
      }
      return afterRatesByCity[citySelect.value] || [];
    }

    function findRateById(rateId) {
      return getRates().find(function (rate) {
        return rate.id === rateId;
      });
    }

    function renderPriceHtml(rate) {
      var parts = [];
      if (rate.compareAtPrice) {
        parts.push(
          '<span class="melo-app-rate-demo-method-compare">' +
            escapeHtml(rate.compareAtPrice) +
            "</span>",
        );
      }
      if (rate.isFree || parsePrice(rate.price) === 0) {
        parts.push(
          '<span class="melo-app-rate-demo-method-free">Gratis</span>',
        );
      } else {
        parts.push(
          '<span class="melo-app-rate-demo-method-price-value">' +
            escapeHtml(rate.price) +
            "</span>",
        );
      }
      return parts.join("");
    }

    function render() {
      var city = cityLabels[citySelect.value] || citySelect.value;
      var rates = getRates();

      if (!isBentoSummaryFocus) {
        methodsEl.innerHTML = rates
          .map(function (rate, index) {
            var selected = index === 0;
            return (
              '<label class="melo-app-rate-demo-method' +
              (selected ? " is-selected" : "") +
              '" data-melo-rate-id="' +
              escapeHtml(rate.id) +
              '">' +
              '<span class="melo-app-rate-demo-method-control">' +
              '<input type="radio" name="' +
              methodRadioName +
              '" value="' +
              escapeHtml(rate.id) +
              '"' +
              (selected ? " checked" : "") +
              ' tabindex="' +
              (userControlled ? "0" : "-1") +
              '"' +
              ">" +
              '<span class="melo-app-rate-demo-method-radio" aria-hidden="true"></span>' +
              "</span>" +
              '<span class="melo-app-rate-demo-method-copy">' +
              '<span class="melo-app-rate-demo-method-title">' +
              escapeHtml(rate.title) +
              "</span>" +
              '<span class="melo-app-rate-demo-method-price">' +
              renderPriceHtml(rate) +
              "</span>" +
              '<span class="melo-app-rate-demo-method-desc">' +
              escapeHtml(rate.description) +
              "</span>" +
              "</span>" +
              "</label>"
            );
          })
          .join("");
      } else if (methodsEl) {
        methodsEl.innerHTML = "";
      }

      // Bento summary ships the selected-tag markup in HBS; don't overwrite it.
      if (rates.length && !isBentoSummaryFocus) {
        updateSummary(rates[0]);
      }

      if (captionEl) {
        if (isBentoStatic) {
          captionEl.hidden = true;
          captionEl.textContent = "";
        } else {
          captionEl.hidden = false;
          captionEl.textContent =
            mode === "before"
              ? scenarioConfig.captionBefore(city)
              : scenarioConfig.captionAfter(city);
        }
      }
    }

    function setMode(nextMode) {
      mode = nextMode;
      if (modeButtons.length) {
        modeButtons.forEach(function (button) {
          var isActive = button.getAttribute("data-melo-rate-mode") === mode;
          button.classList.toggle("is-active", isActive);
          button.setAttribute("aria-selected", isActive ? "true" : "false");
          if (userControlled) {
            button.tabIndex = isActive ? 0 : -1;
          }
        });
      }
      if (panel && beforeButton && afterButton) {
        panel.setAttribute(
          "aria-labelledby",
          mode === "before" ? "rate-demo-tab-before" : "rate-demo-tab-after",
        );
      }
      root.setAttribute("data-mode", mode);
      render();
    }

    function setCity(value) {
      citySelect.value = value;
      syncCityMenuSelection();
      render();
    }

    function getCityOption(value) {
      return cityOptions.find(function (option) {
        return option.getAttribute("data-value") === value;
      });
    }

    function syncCityMenuSelection() {
      cityOptions.forEach(function (option) {
        var isCurrent = option.getAttribute("data-value") === citySelect.value;
        option.classList.toggle("is-current", isCurrent);
        option.classList.remove("is-selected-preview");
      });
    }

    function openCityMenu() {
      if (!citySelectWrap) {
        return;
      }

      syncCityMenuSelection();
      citySelectWrap.classList.add("is-open");

      if (cityMenu) {
        cityMenu.setAttribute("aria-hidden", "false");
      }

      if (embedShell) {
        embedShell.classList.add("is-city-menu-open");
      }

      if (sandbox) {
        sandbox.classList.add("is-city-menu-open");
      }
    }

    function closeCityMenu() {
      if (!citySelectWrap) {
        return;
      }

      citySelectWrap.classList.remove("is-open");

      if (cityMenu) {
        cityMenu.setAttribute("aria-hidden", "true");
      }

      if (embedShell) {
        embedShell.classList.remove("is-city-menu-open");
      }

      if (sandbox) {
        sandbox.classList.remove("is-city-menu-open");
      }

      cityOptions.forEach(function (option) {
        option.classList.remove("is-selected-preview", "is-demo-focus");
      });
    }

    function initUserInteraction() {
      if (userInteractionReady) {
        return;
      }

      userInteractionReady = true;

      modeButtons.forEach(function (button) {
        button.tabIndex = button.classList.contains("is-active") ? 0 : -1;
        button.addEventListener("click", function () {
          setMode(button.getAttribute("data-melo-rate-mode"));
        });
      });

      citySelect.removeAttribute("aria-hidden");
      citySelect.tabIndex = 0;
      citySelect.addEventListener("change", function () {
        closeCityMenu();
        syncCityMenuSelection();
        render();
      });

      methodsEl.addEventListener("change", function (event) {
        if (event.target.name !== methodRadioName) {
          return;
        }

        methodsEl
          .querySelectorAll(".melo-app-rate-demo-method")
          .forEach(function (item) {
            item.classList.toggle(
              "is-selected",
              item.querySelector("input").checked,
            );
          });

        var selectedRate = findRateById(event.target.value);
        if (selectedRate) {
          updateSummary(selectedRate);
        }
      });
    }

    function enableUserControl() {
      if (userControlled) {
        return;
      }

      userControlled = true;
      stopPlayback();

      if (demoStage) {
        demoStage.setAttribute("data-melo-rate-demo-user-controlled", "");
      }

      if (takeControlBtn) {
        takeControlBtn.hidden = true;
      }

      initUserInteraction();
      render();
    }

    function clearDemoFocus() {
      root.querySelectorAll(".is-demo-focus").forEach(function (element) {
        element.classList.remove("is-demo-focus");
      });
    }

    function clearPlaybackTimers() {
      playbackTimeouts.forEach(function (timerId) {
        window.clearTimeout(timerId);
      });
      playbackTimeouts = [];
    }

    function schedulePlayback(callback, delay) {
      var timerId = window.setTimeout(function () {
        if (playbackActive) {
          callback();
        }
      }, delay);
      playbackTimeouts.push(timerId);
      return timerId;
    }

    function getCursorPoint(target) {
      var rootRect = playbackRoot.getBoundingClientRect();
      var targetRect = target.getBoundingClientRect();
      return {
        x: targetRect.left - rootRect.left + targetRect.width * 0.68,
        y: targetRect.top - rootRect.top + targetRect.height * 0.58,
      };
    }

    function moveCursorTo(target, duration, done) {
      if (!cursor || prefersReducedMotion) {
        if (done) {
          done();
        }
        return;
      }

      var point = getCursorPoint(target);
      cursor.classList.add("is-visible");
      cursor.style.setProperty("--cursor-x", point.x + "px");
      cursor.style.setProperty("--cursor-y", point.y + "px");
      cursor.style.transitionDuration = duration + "ms";
      cursor.style.transform =
        "translate(" + point.x + "px, " + point.y + "px)";

      schedulePlayback(function () {
        if (done) {
          done();
        }
      }, duration);
    }

    function clickTarget(target, done) {
      clearDemoFocus();

      if (target) {
        target.classList.add("is-demo-focus");
      }

      if (cursor && !prefersReducedMotion) {
        cursor.classList.add("is-clicking");
        schedulePlayback(function () {
          cursor.classList.remove("is-clicking");
          if (done) {
            done();
          }
        }, 180);
        return;
      }

      schedulePlayback(
        function () {
          if (done) {
            done();
          }
        },
        prefersReducedMotion ? 350 : 120,
      );
    }

    function runSteps(steps, index, onComplete) {
      if (!playbackActive) {
        return;
      }

      if (index >= steps.length) {
        if (onComplete) {
          onComplete();
        }
        return;
      }

      var step = steps[index];

      if (step.wait) {
        schedulePlayback(function () {
          runSteps(steps, index + 1, onComplete);
        }, step.wait);
        return;
      }

      if (step.selectCity) {
        runSelectCityStep(step.selectCity, function () {
          runSteps(steps, index + 1, onComplete);
        });
        return;
      }

      if (step.move) {
        moveCursorTo(step.move, step.duration || 650, function () {
          runSteps(steps, index + 1, onComplete);
        });
        return;
      }

      if (step.click) {
        clickTarget(step.click, function () {
          if (step.action) {
            step.action();
          }
          runSteps(steps, index + 1, onComplete);
        });
        return;
      }

      if (step.action) {
        step.action();
      }

      runSteps(steps, index + 1, onComplete);
    }

    function runSelectCityStep(cityValue, done) {
      var optionEl = getCityOption(cityValue);

      if (!optionEl || !citySelectWrap) {
        setCity(cityValue);
        if (done) {
          done();
        }
        return;
      }

      runSteps(
        [
          { move: citySelectWrap, duration: prefersReducedMotion ? 0 : 560 },
          {
            click: citySelectWrap,
            action: function () {
              openCityMenu();
            },
          },
          { wait: prefersReducedMotion ? 520 : 420 },
          { move: optionEl, duration: prefersReducedMotion ? 0 : 480 },
          {
            click: optionEl,
            action: function () {
              optionEl.classList.add("is-selected-preview");
              setCity(cityValue);
              schedulePlayback(
                function () {
                  closeCityMenu();
                },
                prefersReducedMotion ? 140 : 260,
              );
            },
          },
          { wait: prefersReducedMotion ? 320 : 300 },
        ],
        0,
        done,
      );
    }

    function runPlaybackSteps(steps, index) {
      runSteps(steps, index, function () {
        runPlaybackSequence();
      });
    }

    function runPlaybackSequence() {
      if (!playbackActive || !citySelectWrap) {
        return;
      }

      var steps = [
        { wait: prefersReducedMotion ? 2200 : 1800 },
        { selectCity: "san-francisco" },
        { wait: prefersReducedMotion ? 2400 : 2000 },
        { selectCity: "san-diego" },
        { wait: prefersReducedMotion ? 2400 : 2000 },
        { move: afterButton, duration: prefersReducedMotion ? 0 : 700 },
        {
          click: afterButton,
          action: function () {
            setMode("after");
          },
        },
        { wait: prefersReducedMotion ? 3200 : 2800 },
        { selectCity: "los-angeles" },
        { wait: prefersReducedMotion ? 2200 : 1800 },
        { selectCity: "san-francisco" },
        { wait: prefersReducedMotion ? 2200 : 1800 },
        { move: beforeButton, duration: prefersReducedMotion ? 0 : 700 },
        {
          click: beforeButton,
          action: function () {
            setMode("before");
          },
        },
        { wait: prefersReducedMotion ? 1600 : 1200 },
        { selectCity: "los-angeles" },
        { wait: prefersReducedMotion ? 1800 : 1400 },
      ];

      runPlaybackSteps(steps, 0);
    }

    function stopPlayback() {
      playbackActive = false;
      clearPlaybackTimers();
      clearDemoFocus();
      closeCityMenu();

      if (cursor) {
        cursor.classList.remove("is-visible", "is-clicking");
      }

      if (demoStage) {
        demoStage.removeAttribute("data-melo-rate-demo-autoplay");
      }

      if (takeControlBtn && !userControlled) {
        takeControlBtn.hidden = true;
      }
    }

    function startPlayback() {
      if (playbackActive || userControlled) {
        return;
      }

      playbackActive = true;
      clearPlaybackTimers();
      clearDemoFocus();

      if (demoStage) {
        demoStage.setAttribute("data-melo-rate-demo-autoplay", "");
      }

      if (takeControlBtn) {
        takeControlBtn.hidden = false;
      }

      setMode("before");
      setCity("los-angeles");
      syncCityMenuSelection();
      runPlaybackSequence();
    }

    syncCityMenuSelection();
    setMode("before");

    function initBentoStaticDemo() {
      if (takeControlBtn) {
        takeControlBtn.hidden = true;
      }
      if (cursor) {
        cursor.style.display = "none";
      }
      if (demoStage) {
        demoStage.classList.add("melo-app-rate-demo-stage--bento-static");
        demoStage.setAttribute("data-melo-rate-demo-bento-mode", bentoMode);
      }
      citySelect.value = "los-angeles";
      citySelect.disabled = true;
      citySelect.setAttribute("aria-disabled", "true");
      citySelect.removeAttribute("aria-hidden");
      citySelect.tabIndex = -1;
      setMode(isBentoProblem ? "before" : "after");
    }

    if (isBentoStatic) {
      initBentoStaticDemo();
      return;
    }

    if (takeControlBtn) {
      takeControlBtn.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        enableUserControl();
      });
    }

    if ("IntersectionObserver" in window && demoStage) {
      var playbackObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (userControlled) {
              return;
            }

            if (entry.isIntersecting) {
              startPlayback();
            } else {
              stopPlayback();
            }
          });
        },
        { threshold: 0.35 },
      );
      playbackObserver.observe(demoStage);
    } else if (!userControlled) {
      startPlayback();
    }
  }

  function initTabGroup(root, tabSelector, panelSelector) {
    var tabs = Array.from(root.querySelectorAll(tabSelector));
    var panels = Array.from(root.querySelectorAll(panelSelector));
    if (!tabs.length || !panels.length) {
      return;
    }

    function activate(tab) {
      var panelId = tab.getAttribute("data-panel");
      tabs.forEach(function (item) {
        var isActive = item === tab;
        item.classList.toggle("is-active", isActive);
        item.setAttribute("aria-selected", isActive ? "true" : "false");
        item.tabIndex = isActive ? 0 : -1;
      });
      panels.forEach(function (panel) {
        var isActive = panel.id === panelId;
        panel.classList.toggle("is-active", isActive);
        if (isActive) {
          panel.removeAttribute("hidden");
        } else {
          panel.setAttribute("hidden", "");
        }
      });
    }

    tabs.forEach(function (tab, index) {
      tab.tabIndex = index === 0 ? 0 : -1;
      tab.addEventListener("click", function () {
        activate(tab);
      });
      tab.addEventListener("keydown", function (event) {
        var nextIndex = index;
        if (event.key === "ArrowRight" || event.key === "ArrowDown") {
          nextIndex = (index + 1) % tabs.length;
        } else if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
          nextIndex = (index - 1 + tabs.length) % tabs.length;
        } else if (event.key === "Home") {
          nextIndex = 0;
        } else if (event.key === "End") {
          nextIndex = tabs.length - 1;
        } else {
          return;
        }
        event.preventDefault();
        tabs[nextIndex].focus();
        activate(tabs[nextIndex]);
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".melo-app-page").forEach(initDemoDialog);
    document.querySelectorAll("[data-melo-app-carousel]").forEach(initCarousel);
    document
      .querySelectorAll("[data-melo-feature-tabs]")
      .forEach(initFeatureTabs);
    document.querySelectorAll("[data-melo-rate-demo]").forEach(initRateDemo);
  });
})();
